module.exports = __webpack_public_path__ + "static/media/IMG_0273.bf9ab6c4.jpg";